import { render } from "./Projects_Home.vue?vue&type=template&id=7c040bce&scoped=true"
import script from "./Projects_Home.vue?vue&type=script&lang=js"
export * from "./Projects_Home.vue?vue&type=script&lang=js"

import "./Projects_Home.vue?vue&type=style&index=0&id=7c040bce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c040bce"]])

export default __exports__